import { clamp } from 'lodash';

export interface GeneratePageRangeProps {
  currentPage: number;
  pageSize: number;
  totalReviewsCount: number;
}

export function generatePageRange(props: GeneratePageRangeProps) {
  const { currentPage, pageSize, totalReviewsCount } = props;
  const from = currentPage <= 1 ? 1 : (currentPage - 1) * pageSize + 1;
  const to = clamp(currentPage * pageSize, totalReviewsCount);

  return `${from}-${to}`;
}
